import { useEffect, useState } from "react";
import { NumberInput } from "../../../components/numberInput/numberInput";
import { useParams } from "react-router";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
// import TableAPI from "../../../api/TableAPI";
import AdminAPI from "../../../api/AdminAPI";

import { Text } from "../../../components/text/text";

import styles from "./workerMotivationPage.module.css"

const MotivationSetting = ({ val, setVal, label, error, ...params }) => {
    return (
        <div className={styles.motivation_setting}>
            <Text as="div" variant="caption" className={styles.motivation_setting_label} >{label}</Text>
            <NumberInput error={error} val={val} setVal={setVal} {...params} />
        </div>
    )
}

const initialSettings = (val) => ({
    salaryPerHour: val,
    hoursPerShift: val,
    countShiftsMonthly: val,
    baseSalary: val,
    bonusPercentage: val,
    avgRevenue: val,
});

export const SuperAdminWorkerMotivationPage = () => {
    const [settings, setSettings] = useState(initialSettings(0));
    const { userId } = useParams();

    useEffect(() => {
        if (!userId)
            return;

        AdminAPI
            .fetchUserMotivation(userId)
            .then(setSettings)
            .catch(console.error);
    }, [userId]);

    // const [hours, setHours] = useState(0);
    // const [days, setDays] = useState(0);

    // useEffect(() => {
    //     if (!userId)
    //         return;

    //     TableAPI
    //         .fetchEmployeeTotalShifts(userId)
    //         .then(({ shifts, hours }) => {
    //             setHours(hours);
    //             setDays(shifts);
    //         })
    //         .catch(console.error);
    // }, [userId]);

    return (
        <>
            <AdminHeader title="План для:" userId={userId} />

            <div className={styles.motivation_settings}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", rowGap: "14px", columnGap: "10px" }}>
                    <MotivationSetting disabled label="Кол-во смен в месяце" val={settings.countShiftsMonthly} />
                    <MotivationSetting disabled label="Кол-во часов в смене" val={settings.hoursPerShift} />
                    <MotivationSetting disabled label="Часовая ставка руб./час" val={settings.salaryPerHour} />
                    <MotivationSetting disabled label="Оклад в месяц (если есть)" val={settings.baseSalary} />
                    <MotivationSetting disabled label="Процент бонуса" val={settings.bonusPercentage} />
                    <MotivationSetting disabled label="План по среднему чеку" val={settings.avgRevenue} />
                </div>
            </div>
        </>
    )
}
